// extracted by mini-css-extract-plugin
export var container = "_5d-1";
export var cornerButtonContainer = "_5d-6";
export var disabled = "_5d-2";
export var dragActive = "_5d-3";
export var fileContainer = "_5d-5";
export var hiddenInput = "_5d-4";
export var widthContainer = "_5d-0";